import { render, staticRenderFns } from "./FullDialog2.vue?vue&type=template&id=5b4f98f9&scoped=true"
import script from "./FullDialog2.vue?vue&type=script&lang=js"
export * from "./FullDialog2.vue?vue&type=script&lang=js"
import style0 from "./FullDialog2.vue?vue&type=style&index=0&id=5b4f98f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4f98f9",
  null
  
)

export default component.exports